/**
 * Application-level configuration driven by environment variables.
 *
 * Set these in a .env file at the frontend root (or inject at build/deploy time):
 *
 *   REACT_APP_NAME=My Academy
 *   REACT_APP_TAGLINE=Manage. Monitor. Grow.
 *   REACT_APP_LOGO_PATH=/app-logo.png
 *   REACT_APP_VENDOR_NAME=Your Support Provider
 *   REACT_APP_VENDOR_EMAIL=support@yourdomain.com
 *   REACT_APP_VENDOR_URL=https://example.com/
 *   REACT_APP_VENDOR_PHONE=
 *   REACT_APP_COPYRIGHT_YEAR=2026
 *   REACT_APP_CURRENCY=(optional build fallback; Regional Settings overrides at runtime)
 *   REACT_APP_CURRENCY_LOCALE=(optional build fallback; Regional Settings overrides at runtime)
 */

import { academyYear } from '../utils/regionalFormat';

const appConfig = {
  /** Display name shown in the header, login page, sidebar footer, etc. */
  appName: process.env.REACT_APP_NAME || "ChessDesk",

  /** Short tagline displayed below the app name in the header */
  tagline: process.env.REACT_APP_TAGLINE || "Manage. Monitor. Grow.",

  /** Path to the logo image served from the public folder */
  logoPath: process.env.REACT_APP_LOGO_PATH || "/app-logo.png",

  /** Vendor / developer contact shown in the sidebar and license page */
  vendorName: process.env.REACT_APP_VENDOR_NAME || "Axeron Technologies",
  vendorEmail: process.env.REACT_APP_VENDOR_EMAIL || "support@axerontechnologies.com",
  vendorUrl: process.env.REACT_APP_VENDOR_URL || "https://axerontechnologies.com/",
  vendorPhone: process.env.REACT_APP_VENDOR_PHONE || "",

  /** Year shown in the copyright footer (academy timezone unless overridden). */
  get copyrightYear() {
    if (process.env.REACT_APP_COPYRIGHT_YEAR) {
      return Number(process.env.REACT_APP_COPYRIGHT_YEAR);
    }
    return academyYear();
  },
};

export default appConfig;
